import { useEffect, useState } from "react";
import { X } from "lucide-react";

const STORAGE_KEY = "desktop_banner_dismissed";

export function DesktopBanner() {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    try {
      setDismissed(localStorage.getItem(STORAGE_KEY) === "1");
    } catch {
      setDismissed(false);
    }
  }, []);

  if (dismissed) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* noop */
    }
    setDismissed(true);
  };

  return (
    <div
      className="hidden md:flex items-center justify-center gap-4 px-4 py-2 text-white text-[13px] text-center relative"
      style={{ backgroundColor: "#FF5C5C" }}
    >
      <span>
        📱 Like2Fit is designed for mobile — scan the QR code or open on your phone for the best experience
      </span>
      <img
        src="https://api.qrserver.com/v1/create-qr-code/?size=60x60&data=https://like2fit.com"
        alt="QR code to like2fit.com"
        width={40}
        height={40}
        className="rounded bg-white p-0.5"
      />
      <button
        onClick={dismiss}
        aria-label="Dismiss banner"
        className="ml-2 p-1 rounded hover:bg-white/20 transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
